module.exports = __webpack_public_path__ + "static/media/bg_top_up_option_best_value.871448b4.png";